import { useState, useEffect } from "react";
import Modal from "./Modal";
import AddDocument from "../forms/document/AddDocument";
import { toast } from "react-toastify";
import { API_URL } from "../ApiConfig";

const Document = ({
  title,
  message,
  onAdd, // ✅ callback to refresh parent data
  appliesTo,
  buttonText = "Upload Document",
  driver,
  documentId,
  existingDoc,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    const tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new window.bootstrap.Tooltip(tooltipTriggerEl);
    });
  }, []);

  const handleViewFiles = () => {
    if (!existingDoc?.filePath?.length) {
      toast.info("No files uploaded yet!", {
        position: "top-right",
        autoClose: 2000,
      });
      return;
    }

    existingDoc.filePath.forEach((path) => {
      window.open(`${API_URL}${path}`, "_blank");
    });
  };

  return (
    <div
      className={`card shadow-sm mb-4 border-0 transition-all duration-300 ${
        hovered ? "shadow-lg scale-105" : ""
      }`}
      style={{ width: "60%", margin: "auto", borderRadius: "12px" }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Header */}
      <div className="card-header bg-primary text-white text-center py-3 rounded-top">
        <h5 className="mb-0">{title}</h5>
      </div>

      {/* Body */}
      <div className="card-body text-center d-flex flex-column align-items-center gap-3">
        <p className="text-muted">{message}</p>

        {existingDoc ? (
          <div className="d-flex flex-column align-items-center gap-2">
            <button
              type="button"
              className="btn btn-outline-success btn-sm d-flex align-items-center gap-2"
              onClick={handleViewFiles}
              data-bs-toggle="tooltip"
              title="View all uploaded files"
            >
              <i className="fa fa-eye"></i> View Document
            </button>

            <small className="text-secondary">
              Uploaded files: <strong>{existingDoc.filePath.length}</strong>
            </small>
          </div>
        ) : (
          <button
            type="button"
            className="btn btn-primary btn-sm d-flex align-items-center gap-2"
            onClick={() => setShowModal(true)}
            data-bs-toggle="tooltip"
            title="Click to upload new documents"
          >
            <i className="fa fa-file-upload"></i> {buttonText}
          </button>
        )}
      </div>

      {/* Footer */}
      <div className="card-footer bg-light text-center">
        {existingDoc ? (
          <span className="badge bg-success px-3 py-2">
            Uploaded on:{" "}
            {new Date(existingDoc.createdAt).toLocaleDateString("en-GB")}
          </span>
        ) : (
          <span className="badge bg-danger px-3 py-2">
            No documents uploaded yet
          </span>
        )}
      </div>

      {/* ✅ Modal with refresh callback */}
      <Modal showModal={showModal} setShowModal={setShowModal}>
        <AddDocument
          name={title}
          appliesTo={appliesTo}
          driver={driver}
          documentId={documentId}
          setShowModal={setShowModal}
          onSuccess={() => {
            if (onAdd) onAdd(); // ✅ trigger parent refresh
          }}
        />
      </Modal>
    </div>
  );
};

export default Document;
